module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/photographer_sns_03-5538d95e4ec0ce9a1d2db6ff873fbed4.jpg";